import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/contact-banner.webp";

const Contact = ({ onClose, eventName }) => {
  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Contact"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "In case you need any help please speak to a representative at Mastercard Welcome Desk or email at:"
              }
            </p>
            <div className="mb-0">
              <p>
                <a href="mailto:contact@experiencecannes.com">
                  contact@experiencecannes.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default Contact;
